module.exports = __webpack_public_path__ + "static/model-poster-8487fe2714c002cf37a71e37a38170d7.jpg";